/**
 * Formats the given phone number to add spaces and symbols
 * @param {string} - Phone number to be formatted
 * @returns {string}  - Formatted phone number
 */
export const formatPhoneNumberNoPrefix = (value) => {
    if (!value) return value
    const phoneNumber = value.replace(/[^\d]/g, '')
    return phoneNumber
}

export const validateNumber = (value) => {
    return {
        vatNumber: value && /^([A-Z]{2})([0-9A-Za-z+*.]{2,12})$/.test(value),
    }
}
